<div class="pass-checkout-page">
    <div class="btn-back-detail" (click)="goBack()">
        <i class="fal fa-arrow-left"></i>
        <span>Ver abonados</span>
    </div>

    <div *ngIf="!loaded" class="loading-container">
        <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
            containerClass="loading-box"></ng-lottie>
    </div>

    <!-- Error de carga -->
    <div class="form-card error-card" *ngIf="loaded && loadErrorMsg">
        <i class="fal fa-circle-exclamation"></i>
        <p class="m-0">{{ loadErrorMsg }}</p>
        <button type="button" class="btn-cancel" (click)="skipPayment()">Cobrar más tarde</button>
    </div>

    <!-- El resumen se mantiene visible durante el cobro: solo el botón cambia a
         «Cobrando...», para que el operador no pierda de vista qué se cobra. -->
    <div class="checkout-layout" *ngIf="loaded && !loadErrorMsg && seasonPass">
        <!-- Columna izquierda -->
        <div class="form-column">

            <!-- Resumen del abono -->
            <div class="form-card">
                <div class="card-header">
                    <i class="fal fa-id-card card-icon"></i>
                    <div>
                        <h2>Abono creado</h2>
                        <p class="card-subtitle">Elige el importe y cóbralo para activarlo</p>
                    </div>
                </div>

                <div class="pass-summary">
                    <div class="pass-summary-row">
                        <i class="fal fa-user"></i>
                        <span>{{ seasonPass.user?.name }}<ng-container *ngIf="seasonPass.user?.nif"> · {{ seasonPass.user?.nif }}</ng-container></span>
                    </div>
                    <div class="pass-summary-row" *ngIf="seasonPass.season?.name">
                        <i class="fal fa-calendar-range"></i>
                        <span>{{ seasonPass.season?.name }}</span>
                    </div>
                    <div class="pass-summary-row" *ngIf="seasonPass.category?.name">
                        <i class="fal fa-tags"></i>
                        <span>{{ seasonPass.category?.name }}</span>
                    </div>
                    <div class="pass-summary-row" *ngIf="seatDisplay">
                        <i class="fal fa-chair"></i>
                        <span>{{ seatDisplay }}</span>
                    </div>
                </div>
            </div>

            <!-- Selección de producto -->
            <div class="form-card" *ngIf="products.length > 1">
                <div class="card-header">
                    <i class="fal fa-euro-sign card-icon"></i>
                    <div>
                        <h2>Importe</h2>
                        <p class="card-subtitle">Hay varias opciones para esta categoría</p>
                    </div>
                </div>

                <div class="product-options">
                    <button type="button" class="product-option" *ngFor="let p of products"
                        [class.selected]="selectedProduct?.id === p.id" (click)="selectProduct(p)">
                        <i class="fa-solid fa-circle-check check-icon"></i>
                        <div class="product-option-info">
                            <p class="product-option-name m-0">{{ p.name }}</p>
                            <p class="product-option-desc m-0" *ngIf="p.description">{{ p.description }}</p>
                        </div>
                        <span class="product-option-price">{{ p.price | number: '1.2-2' }} €</span>
                    </button>
                </div>
            </div>

            <!-- Cobro en taquilla -->
            <div class="form-card">
                <div class="card-header">
                    <i class="fal fa-cash-register card-icon"></i>
                    <div>
                        <h2>Cobro en taquilla</h2>
                        <p class="card-subtitle">Cobro presencial, sin pasarela de pago</p>
                    </div>
                </div>

                <span class="field-hint">
                    <i class="fal fa-info-circle"></i> Al pulsar «Cobrar» el cobro queda registrado al instante y el abono se activa. El cobro en taquilla no lleva gastos de gestión.
                </span>
            </div>
        </div>

        <!-- Columna derecha: total y acciones -->
        <div class="preview-column">
            <div class="form-card summary-card">
                <p class="summary-title">Resumen</p>

                <div class="summary-row">
                    <span>{{ selectedProduct?.name }}</span>
                    <span>{{ subtotal | number: '1.2-2' }} €</span>
                </div>
                <div class="summary-divider"></div>
                <div class="summary-row summary-total">
                    <span>Total <span class="iva">(IVA inc.)</span></span>
                    <span>{{ totalPrice | number: '1.2-2' }} €</span>
                </div>

                <button type="button" class="btn-save" [disabled]="!selectedProduct || waiting" (click)="pay()">
                    <i class="fal fa-circle-check"></i>
                    {{ waiting ? 'Cobrando...' : ('Cobrar · ' + (totalPrice | number: '1.2-2') + ' €') }}
                </button>
                <button type="button" class="btn-cancel" [disabled]="waiting" (click)="skipPayment()">
                    Cobrar más tarde
                </button>
            </div>
        </div>
    </div>
</div>
